export default (state: any, action: any) => ({
  ...state,
  leadsPool: {
    ...state.leadsPool,
    hasError: action.hasError,
  },
});
